import React from 'react'

import CmsItemBasic from 'components/CmsItem/CmsItemBasic'
import Spinner from 'components/Spinner/Spinner'
import usePage from 'hooks/usePage'

type CmsContentProps = {
  slug: string
}

const CmsContent: React.FC<CmsContentProps> = ({ slug }) => {
  const { page, loading, error } = usePage(slug)

  const CmsItems = page?.publicCmsItems.map((item) => {
    if (item.type === 'ProfileCollectionTagList') {
      return { ...item, type: 'CategoriesContentSmall' }
    }
    return item
  })

  if (error) return null

  return (
    <>
      {loading && <Spinner height={30} centered />}
      {CmsItems?.map((cmsItem) => (
        <CmsItemBasic key={cmsItem.id} item={cmsItem} wrapItems="false" />
      ))}
    </>
  )
}

export default CmsContent
